import { Injectable } from '@angular/core';
import { PatientInformation } from '@core/models/patient-registration/patient-information';
import {State, Action, StateContext, Selector} from '@ngxs/store';
import {clearPatientIdVisitIdAction, storePatientIdVisitIdAction} from './erdashboard.action'
export class storePatientIdVisitIdModel{
    patientId:any;
    visitId:any;
 gender:string;
 patientModel:PatientInformation;
//  mnemonic:string;
//  visitTime:string;
 }
 @State<storePatientIdVisitIdModel>({
     name: 'patientIdVisitId',
     defaults: {
        patientId:0,
        visitId:0,
        gender:'',
        patientModel:null,
        // mnemonic:'',
       // visitTime:''
      }
 })
 @Injectable()
 export class storePatientIdVisitIdState {
 
     constructor( ) {
     }
 
     @Selector()
     static getPatientIdVisitId(state: storePatientIdVisitIdModel) {
         return state;
     }
     @Action(storePatientIdVisitIdAction)
     storePatientIdVisitIdAction({getState, patchState}: StateContext<storePatientIdVisitIdModel>, {payload}: storePatientIdVisitIdAction) {
         const state = getState();
         patchState({
              patientId:payload.patientId,
              visitId:payload.visitId,
              gender:payload.gender,
              patientModel:payload.patientModel,
            //   mnemonic:payload.mnemonic,
             // visitTime:payload.visitTime
         });
     }
 
     @Action(clearPatientIdVisitIdAction)
     clearPatientIdVisitIdAction({getState, patchState}: StateContext<storePatientIdVisitIdModel>, {payload}: clearPatientIdVisitIdAction) {
         const state = getState();
         patchState({
              patientId:0,
              visitId:0,
              gender:'',
              patientModel:null,
            //   mnemonic:payload.mnemonic,
             // visitTime:payload.visitTime
         });
     }

    //  @Action(storePatientBedDetailsAction)
    //  storePatientBedDetailsAction({getState, patchState}: StateContext<storePatientIdVisitIdModel>, {payload}: any) {
    //      const state = getState();
    //      let patientModel = JSON.parse(JSON.stringify(state.patientModel));
    //      patientModel.bedName = payload.bedName;
    //      patientModel.bedId =   payload.bedId;
    //      patientModel.nursingStation =payload.nursingStation
    //      patientModel.nursingStationId =payload.nursingStationId
    //      patientModel.roomName = payload.roomName
    //      patientModel.roomId = payload.roomId
    //      patientModel.floorId = payload.floorId
    //      patientModel.departmentId =payload.departmentId
    //       patchState({
    //         patientModel: patientModel
    //       });
    //   }
    } 